module.exports = __webpack_public_path__ + "static/img/pc_movie.3f7539db.png";